import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'

import styles from './BackButton.module.scss'

/**
 * Унифицированная кнопка «Назад».
 *
 * Вместо разрозненных inline `<button onClick={() => navigate(-1)}>`.
 * Если `to` задан — навигирует туда; иначе — `navigate(-1)`.
 *
 * Поддерживает:
 *  - `aria-label` через i18n key `common.back` (fallback «Назад»)
 *  - keyboard focus / Enter (нативный `<button>`)
 *  - вариант `variant`: 'default' | 'ghost' | 'icon'
 */
function BackButton({
  to,
  variant = 'default',
  className,
  children,
  onClick,
  ...rest
}) {
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  const handleClick = (e) => {
    if (onClick) onClick(e)
    if (e.defaultPrevented) return
    if (to) {
      navigate(to)
    } else {
      navigate(-1)
    }
  }

  const label = t('common.back', 'Назад')
  const cls = [styles.btn, styles[`v_${variant}`], className].filter(Boolean).join(' ')

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={children ? undefined : label}
      title={label}
      className={cls}
      {...rest}
    >
      <span className={styles.icon} aria-hidden="true">
        <Icon name="chevron-left" size={16} color="currentColor" />
      </span>
      {children !== undefined ? children : (
        <span className={styles.text}>{label}</span>
      )}
    </button>
  )
}

export default BackButton
